import { Component, OnDestroy, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { MapService } from 'src/app/shared/components/map/map.service';
import { ProjectQuery } from '../state/project.query';
import { ProjectService } from '../state/project.service';
import { FeatureCollection } from 'geojson';
import * as mapboxgl from 'mapbox-gl';

@Component({
  selector: 'app-project-square',
  template: ''
})
export class ProjectSquareComponent implements OnInit, OnDestroy {

  constructor(
    private projectService: ProjectService,
    private projectQuery: ProjectQuery,
    private mapService: MapService
  ) { }


  ngOnInit(): void {
    const projectId = this.projectQuery.getActiveId();

    this.projectService.getSquare(projectId)
      .pipe(take(1))
      .subscribe(result => this.loadSquare(result));

  }

  ngOnDestroy(): void {
    this.mapService.map$.subscribe(mapbox => {

      if (mapbox.getLayer(LAYER_ID)) {
        mapbox.removeLayer(LAYER_ID);
      }
      if (mapbox.getSource(SOURCE_ID)) {
        mapbox.removeSource(SOURCE_ID);
      }
    });
  }

  private loadSquare(result: FeatureCollection): void {
    this.mapService.map$.subscribe(mapbox => {

      this.createSource(mapbox, result);
      this.createLayer(mapbox);
    });
  }

  private createSource(mapbox: mapboxgl.Map, data: FeatureCollection) {
    mapbox.addSource(SOURCE_ID, {
      type: 'geojson',
      data
    });
  }

  private createLayer(mapbox: mapboxgl.Map) {
    mapbox.addLayer(LAYER);
  }

}

const LAYER_ID = 'mitra-square';
const SOURCE_ID = LAYER_ID + '-source';

const LAYER = {
  id: LAYER_ID,
  source: SOURCE_ID,
  type: 'line',
  minzoom: 12,
  layout: {
    visibility: 'none'
  },
  paint: {
    'line-color': '#C1AE9F',
    'line-width': 1,
    'line-opacity': 0.7,
    'line-dasharray': [2, 5]
  }
} as mapboxgl.Layer;
